import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/sftp/dashboard")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/developer/sftp/diaries", search, replace: true });
    },
});
